interface TtsProps {
  isTrial: boolean;
  appId: string;
  firstRunEnabled?: boolean;
  tid: string;
  currentUser: string;
  isMobile?: boolean;
}

export const NewTtsPreview = ({
  isTrial,
  appId,
  firstRunEnabled,
  tid,
  currentUser,
  isMobile,
}: TtsProps) => {
  return <h1>TTS Preview</h1>;
};
